import * as React from "react";
export const SuccessIconV2 = (props) => (
	<svg
		fill="none"
		height={69}
		viewBox="0 0 69 69"
		width={69}
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M68.75 34.75C68.75 53.5277 53.5277 68.75 34.75 68.75C15.9723 68.75 0.75 53.5277 0.75 34.75C0.75 15.9723 15.9723 0.75 34.75 0.75C53.5277 0.75 68.75 15.9723 68.75 34.75ZM3.92911 34.75C3.92911 51.7719 17.7281 65.5709 34.75 65.5709C51.7719 65.5709 65.5709 51.7719 65.5709 34.75C65.5709 17.7281 51.7719 3.92911 34.75 3.92911C17.7281 3.92911 3.92911 17.7281 3.92911 34.75Z"
			fill="#0B9159"
		/>
		<path
			d="M51.0574 23.5225L29.9794 44.6005L20.3984 35.0196"
			stroke="#0B9159"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={3.93064}
		/>
	</svg>
);
